export function isDateOutOfRange(dateData, minValue, maxValue) {
  const date = new Date(dateData.year, dateData.month - 1, dateData.day);
  const conditions = [];
  if (minValue) {
    const firstDate = new Date(minValue.year, minValue.month - 1, minValue.day);
    conditions.push(date.getTime() < firstDate.getTime());
  }
  if (maxValue) {
    const lastDate = new Date(maxValue.year, maxValue.month - 1, maxValue.day);
    conditions.push(date.getTime() > lastDate.getTime());
  }
  return conditions.some(Boolean);
}